import api from '@/api';

const state = {
  examList: [],
  currentExam: {},
  examStatistics: {},
  questionBank: [],
  userList: []
};

const getters = {
  examList: state => state.examList,
  currentExam: state => state.currentExam,
  examStatistics: state => state.examStatistics,
  questionBank: state => state.questionBank,
  userList: state => state.userList
};

const mutations = {
  SET_EXAM_LIST(state, examList) {
    state.examList = examList;
  },
  
  SET_CURRENT_EXAM(state, exam) {
    state.currentExam = exam;
  },
  
  SET_EXAM_STATISTICS(state, statistics) {
    state.examStatistics = statistics;
  },
  
  SET_QUESTION_BANK(state, questionBank) {
    state.questionBank = questionBank;
  },
  
  SET_USER_LIST(state, userList) {
    state.userList = userList;
  },
  
  ADD_EXAM(state, exam) {
    state.examList.unshift(exam);
  },
  
  UPDATE_EXAM(state, updatedExam) {
    const index = state.examList.findIndex(exam => exam.id === updatedExam.id);
    if (index !== -1) {
      state.examList.splice(index, 1, updatedExam);
    }
  },
  
  DELETE_EXAM(state, examId) {
    state.examList = state.examList.filter(exam => exam.id !== examId);
  }
};

const actions = {
  // 获取考试列表
  async fetchExamList({ commit }, params = {}) {
    try {
      const response = await api.exam.getExamList(params);
      commit('SET_EXAM_LIST', response.data.list || response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 获取考试详情
  async fetchExamDetail({ commit }, examId) {
    try {
      const response = await api.exam.getExamDetail(examId);
      commit('SET_CURRENT_EXAM', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 创建考试
  async createExam({ commit }, examData) {
    try {
      const response = await api.exam.createExam(examData);
      commit('ADD_EXAM', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新考试
  async updateExam({ commit }, { examId, examData }) {
    try {
      const response = await api.exam.updateExam(examId, examData);
      commit('UPDATE_EXAM', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 删除考试
  async deleteExam({ commit }, examId) {
    try {
      const response = await api.exam.deleteExam(examId);
      commit('DELETE_EXAM', examId);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 获取考试统计
  async fetchExamStatistics({ commit }, examId) {
    try {
      const response = await api.exam.getExamStatistics(examId);
      commit('SET_EXAM_STATISTICS', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 获取题库
  async fetchQuestionBank({ commit }, params = {}) {
    try {
      const response = await api.question.getQuestionBank(params);
      commit('SET_QUESTION_BANK', response.data.list || response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 获取用户列表
  async fetchUserList({ commit }, params = {}) {
    try {
      const response = await api.user.getUserList(params);
      commit('SET_USER_LIST', response.data.list || response.data);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
